module.exports = __webpack_public_path__ + "img/product-paceholder.38ca0ce1.png";